import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow_right_orange",
  "use": "icon-arrow_right_orange-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"icon-arrow_right_orange\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h28v28H0z\" /><path fill=\"#FF6000\" d=\"M15.367 14 9.592 8.225l1.65-1.65L18.667 14l-7.425 7.425-1.65-1.65z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol